import classNames from "classnames";
import { EmphasizedText } from "PFComponents/emphasized_text";
import { Typography } from "PFComponents/typography";
import { PlainSearchHighlight } from "PFTypes";
import React, { Fragment } from "react";

import css from "./search_highlight_plain_row.module.scss";

type SearchHighlightPlainRowProps = {
  attributeDisplayName: string;
  values: PlainSearchHighlight;
  indented?: boolean;
  noMargin?: boolean;
};

export const SearchHighlightPlainRow = ({
  attributeDisplayName,
  values,
  indented
}: SearchHighlightPlainRowProps) => (
  <Fragment>
    <Typography
      variant={indented ? "bodyRegular" : "bodyBold"}
      className={classNames({ [css.indented]: indented })}
    >
      {attributeDisplayName}
    </Typography>
    <EmphasizedText
      text={values.join(", ")}
      variant="bodyRegular"
      emphasizedVariant="bodyBold"
      className={css.values}
      emphasizedClassName={css.emphasizedClassName}
    />
  </Fragment>
);
